export default __webpack_public_path__ + "static/multimonth-3x4-88c31e2adc1c18f44d280b35cd238ef7.png";